export default function imageWidget(editor) {
  editor.DomComponents.addType('eb-image', {
    extend: 'image',
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-image'
    },
    model: {
      defaults: {
        name: 'Image',
        tagName: 'img',
        void: true,
        droppable: false,
        resizable: { ratioDefault: true },
        attributes: {
          'data-gjs-type': 'eb-image',
          src: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMjAwIiB2aWV3Qm94PSIwIDAgMzAwIDIwMCI+PHJlY3Qgd2lkdGg9IjMwMCIgaGVpZ2h0PSIyMDAiIGZpbGw9IiNlMGUwZTAiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE4IiBmaWxsPSIjOTk5Ij5JbWFnZSBQbGFjZWhvbGRlcjwvdGV4dD48L3N2Zz4=',
          alt: 'Image',
        },
        style: {
          'max-width': '100%',
          'height': 'auto',
          'display': 'block',
        },
        traits: [
          { type: 'text', name: 'src', label: 'Image URL' },
          { type: 'text', name: 'alt', label: 'Alt Text' },
          { type: 'text', name: 'title', label: 'Title' },
          {
            type: 'select', name: 'loading', label: 'Loading',
            options: [
              { id: 'lazy', label: 'Lazy' },
              { id: 'eager', label: 'Eager' },
            ],
          },
        ],
      },
    },
  })

  editor.BlockManager.add('eb-image', {
    label: 'Image',
    category: 'Basic',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M21,3H3C2,3 1,4 1,5V19A2,2 0 0,0 3,21H21C22,21 23,20 23,19V5C23,4 22,3 21,3M5,17L8.5,12.5L11,15.5L14.5,11L19,17H5Z"/></svg>',
    content: { type: 'eb-image' },
    activate: true,
  })
}
